var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HeartColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.20156726e-06%",
    y1: "35.3806708%",
    x2: "100.032006%",
    y2: "37.7919267%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21.0%",
    y: "-36.3%",
    width: "142.0%",
    height: "172.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "21.4351387%",
    x2: "100.117483%",
    y2: "23.8484019%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.0560163258,76.5874037 C0.229016326,86.0031037 4.16591633,96.5901037 13.3228163,107.988004 C88.5490163,128.061004 142.941016,104.654004 143.050016,83.8607037 L143.050016,51.0908037 L143.048016,51.0907037 C143.219016,40.4209037 129.130016,30.4136037 96.2670163,27.2872037 C83.1900163,-19.3866963 -1.05398367,-0.940341207 0.0610163258,43.9192037 L0.0500163258,43.9186037 C0.0500163258,58.0616037 0.0500163258,62.4442037 0.0500163258,76.5871037 L0.0560163258,76.5874037 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.9%",
    y: "-7.4%",
    width: "111.9%",
    height: "114.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84846244%",
    y1: "49.4736023%",
    x2: "96.9697732%",
    y2: "49.4736023%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.3228163,75.0895037 C126.976016,105.416004 193.072016,36.4968037 96.2680163,27.2872037 C80.4620163,-29.1229963 -39.2979437,9.58930367 13.3228163,75.0895037 Z M39.7314163,57.2602037 C87.8040163,70.0875037 115.761016,40.9363037 74.8150163,37.0409037 C68.1298163,13.1807037 17.4740163,29.5551037 39.7314163,57.2602037 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-1.8%",
    width: "102.1%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.88003058%",
    y1: "49.474313%",
    x2: "96.9372216%",
    y2: "49.474313%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.6358958%",
    y1: "43.892162%",
    x2: "46.8451711%",
    y2: "72.338853%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.502153835%",
    y1: "27.2634796%",
    x2: "31.8163995%",
    y2: "93.2608676%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HeartColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heart",
    transform: "translate(23.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3228163,119.393004 C126.976016,149.719004 193.072016,80.8001037 96.2680163,71.5905037 C80.4620163,15.1804037 -39.2979437,53.8927037 13.3228163,119.393004 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.3099163,75.1378037 C41.7289163,82.7209037 67.1762163,84.1002037 87.8490163,81.7590037 C108.521016,79.4180037 124.423016,73.3563037 133.748016,66.0536037 C138.410016,62.4023037 141.432016,58.4378037 142.579016,54.4694037 C143.728016,50.4985037 142.998016,46.5288037 140.169016,42.8756037 C137.340016,39.2243037 132.416016,35.8908037 125.176016,33.1824037 C117.935016,30.4737037 108.376016,28.3889037 96.2720163,27.2374037 L96.2630163,27.3370037 C108.360016,28.4879037 117.911016,30.5714037 125.141016,33.2760037 C132.371016,35.9809037 137.277016,39.3057037 140.090016,42.9368037 C142.901016,46.5660037 143.623016,50.5028037 142.483016,54.4416037 C141.343016,58.3828037 138.339016,62.3311037 133.686016,65.9749037 C124.381016,73.2623037 108.499016,79.3198037 87.8380163,81.6596037 C67.1781163,83.9993037 41.7434163,82.6212037 13.3357163,75.0412037 L13.3099163,75.1378037 Z M96.3160163,27.2737037 C92.3590163,13.1509037 81.8940163,4.98246367 69.2520163,1.69889367 C56.6122163,-1.58422233 41.7935163,0.0150926731 29.1157163,5.42597367 C16.4383163,10.8367037 5.89421633,20.0623037 1.81361633,32.0387037 C-2.26798367,44.0179037 0.121016326,58.7362037 13.2838163,75.1208037 L13.3618163,75.0582037 C0.214216326,58.6927037 -2.15948367,44.0094037 1.90821633,32.0709037 C5.97691633,20.1297037 16.4943163,10.9215037 29.1550163,5.51794367 C41.8153163,0.114493673 56.6113163,-1.48112033 69.2270163,1.79568367 C81.8410163,5.07204367 92.2740163,13.2184037 96.2190163,27.3007037 L96.3160163,27.2737037 Z M39.7185163,57.3085037 C51.7423163,60.5168037 62.5096163,61.1006037 71.2580163,60.1099037 C80.0040163,59.1194037 86.7360163,56.5542037 90.6860163,53.4609037 C92.6610163,51.9143037 93.9440163,50.2328037 94.4320163,48.5464037 C94.9200163,46.8575037 94.6090163,45.1689037 93.4070163,43.6168037 C92.2060163,42.0665037 90.1180163,40.6540037 87.0530163,39.5074037 C83.9870163,38.3606037 79.9410163,37.4783037 74.8200163,36.9911037 L74.8100163,37.0907037 C79.9260163,37.5773037 83.9630163,38.4582037 87.0180163,39.6011037 C90.0730163,40.7441037 92.1430163,42.1479037 93.3280163,43.6780037 C94.5120163,45.2061037 94.8150163,46.8618037 94.3360163,48.5186037 C93.8560163,50.1778037 92.5900163,51.8432037 90.6240163,53.3822037 C86.6940163,56.4602037 79.9820163,59.0212037 71.2460163,60.0106037 C62.5115163,60.9998037 51.7568163,60.4172037 39.7443163,57.2119037 L39.7185163,57.3085037 Z M74.8630163,37.0274037 C73.1860163,31.0421037 68.7507163,27.5806037 63.3955163,26.1897037 C58.0420163,24.7992037 51.7675163,25.4767037 46.4001163,27.7676037 C41.0330163,30.0582037 36.5654163,33.9655037 34.8359163,39.0414037 C33.1055163,44.1200037 34.1204163,50.3557037 39.6924163,57.2915037 L39.7704163,57.2289037 C34.2136163,50.3121037 33.2140163,44.1116037 34.9306163,39.0736037 C36.6481163,34.0329037 41.0890163,30.1431037 46.4394163,27.8595037 C51.7894163,25.5761037 58.0412163,24.9023037 63.3704163,26.2865037 C68.6979163,27.6702037 73.1010163,31.1096037 74.7670163,37.0544037 L74.8630163,37.0274037 Z",
    id: "Shape",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7314163,57.2602037 C87.8040163,70.0875037 115.761016,40.9364037 74.8150163,37.0409037 C68.1299163,13.1807037 17.4740163,29.5551037 39.7314163,57.2602037 Z",
    id: "Path",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8160163,59.5528037 C98.1460163,55.5172037 104.087016,39.8257037 74.8160163,37.0410037 L74.8160163,59.5528037 Z",
    id: "Path",
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartColor);
export default __webpack_public_path__ + "static/media/HeartColor.2c28d2b4ec04b35e6ba5186a3aa44023.svg";
export { ForwardRef as ReactComponent };